import React from 'react';
import View from './View';


const LeftNav = (props: any) => <View {...props} />;

export default LeftNav;
